import { createContext } from 'react'

export const ClinicDataContext = createContext(null)

export function ClinicDataProvider({
  chosenRoleFlow,
  ownerData,
  assistantData,
  refreshOwnerAssociatedClinicsData,
  refreshOwnerAssociatedClinicBrandsData,
  refreshOwnerAssociatedClinicChambersData,
  setShowSidebar,
  children,
}) {
  return (
    <ClinicDataContext.Provider
      value={{
        chosenRoleFlow,
        ownerData,
        assistantData,
        refreshOwnerAssociatedClinicsData,
        refreshOwnerAssociatedClinicBrandsData,
        refreshOwnerAssociatedClinicChambersData,
      }}
    >
      {children}
    </ClinicDataContext.Provider>
  )
}
